howspace.components.oembed = (() => {
    'use strict';

    const oembedClick = (e) => {
        if (e.type === 'keypress' && e.which !== 13 && e.which !== 32) {
            return;
        }

        const oembed = $(e.target).closest('.howspace-oembed');

        if (oembed.is('.video')) {
            initVideoPlayer(oembed);
        }
    };

    const initVideoPlayer = (oembed) => {
        // Destroy any existing oembed video players
        destroyVideoPlayer($('.howspace-oembed-videoplayer-initialized'));

        const obj = oembed.data('oembed');

        oembed.addClass('howspace-oembed-videoplayer-initialized');
        oembed.find('.oembed-content').html(obj.html);
    };

    const destroyVideoPlayer = function (oembed) {
        if (!oembed.is('.howspace-oembed-videoplayer-initialized')) {
            return false;
        }

        oembed.removeClass('howspace-oembed-videoplayer-initialized');
        oembed.find('.oembed-content').html('');
    };

    return {
        init: function (elem) {
            elem.findIncludingSelf('.howspace-oembed:not(.howspace-oembed-initialized)').each(function () {
                const oembed = $(this);

                oembed.addClass('howspace-oembed-initialized');

                oembed.on('click keypress', oembedClick);

            });
        },

        destroy: function (elem) {
            elem.findIncludingSelf('.howspace-oembed.howspace-oembed-initialized').each(function () {
                const oembed = $(this);

                oembed.removeClass('howspace-oembed-initialized');

                oembed.off('click', oembedClick);

                oembed.find('.oembed-content').html('');
            });
        },

        destroyVideoPlayer: destroyVideoPlayer
    };

})();
